import { zodResolver } from '@hookform/resolvers/zod';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { ProgressBar } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { ThreatsBars } from '../../../components/operator-dashboard/threats-box/ThreatsBars';
import './Threats.scss';
type Props = {
  darkmode: any;
  summaryData: any;
};

export const ThreatsByType = (props: Props) => {
  const navigate = useNavigate();
  const { operatorId, cpeId, deviceId } = useParams();
  const { t } = useTranslation();
  // const deviceId: number = props.summaryData.id;

  const [accountsData, setAccountsData] = useState<any>('#35B83A');

  const [selectedRange, setSelectedRange] = useState<number>(1);

  const handleDateRangeChange = (days: number) => {
    setSelectedRange(days);
  };

  const handleSelectedRangeChange = (selectedRange: number) => {
    // Handle the selectedRange value in the parent component
    fetchApi(selectedRange);
  };
  // async function fetchApi(selectedRange: number | undefined = 1) {
  //   try {
  //     const threatsMitigated = await axios.get(`/op/dashboard/threats-mitigated?days=${selectedRange}`);
  //     setAccountsData(threatsMitigated.data);
  //   } catch (error) {
  //     // Handle any errors that occur during the API calls
  //     console.error('Error fetching API data:', error);
  //   }
  // }

  async function fetchApi(selectedRange: number | undefined = 1) {
    try {

      const threatsMitigated = await axios.get(`/v2/op/device/${deviceId}/device-threats?days=${selectedRange}`);
      setAccountsData(threatsMitigated.data);
    } catch (error) {
      console.error('Error fetching API data:', error);
    }
  }

  console.log(accountsData)

  return (
    <section className="dd-threats">
      <header className="dd-threats-hd">
        <span className="dd-threats-icon" aria-hidden="true">
          <ShieldAlert size={16} strokeWidth={1.75} />
        </span>
        <div className="dd-threats-hd-text">
          <h2 className="bd-h2">{t('deviceDetails.threats.title')}</h2>
          <span className="bd-meta">{t('deviceDetails.threats.subtitle')}</span>
        </div>
      </header>
      <div className="dd-threats-body">
        <ThreatsBars darkmode={props.darkmode} accountsData={accountsData} onSelectedRangeChange={handleSelectedRangeChange} />
      </div>
    </section>
  );
};
